import { theme } from "../../../theme";

export const category = {
  centerDiv: {
    height: "100%",
    width: "100%",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  formRoot: {
    "& .MuiFormControl-root": {
      m: 0,
    },
    "& .MuiFormHelperText-root ": {
      mx: 0,
    },
  },
  listItem: {
    cursor: "default",
    "&:hover": {
      background: theme.palette.primary.main,
      "& .MuiListItemText-root .MuiTypography-root, & svg": {
        color: "#fff",
      },
      "& .Mui-disabled svg": {
        color: theme.palette.primary.light,
      },
    },
  },
  loadingDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 255px)",
    width: "100%",
    "& > div": {
      m: 0,
      height: "auto",
    },
  },
  mainDiv: { height: "calc(100vh - 255px)", width: "100%", minWidth: "460px" },
  innerDiv:{ display: "flex", flexDirection: "column", height: "100%" },
  iconStyle:{position: "relative",color: theme.palette.grey[800],fontSize: "18px",},
} as const;
